import React from 'react';
import PropTypes from 'prop-types';
import 'react-day-picker/lib/style.css';
import { DatepickerProvider } from './context';
import Datepicker from './Datepicker/Datepicker';
import { DATE_PICKER_TYPE, DEFAULT_DATE_FORMAT, isRangeSelectionDatePicker } from './utils/helper';
import '@dtsl/css-datepicker/dist/index.css';
function DatepickerWrapper(props) {
  const {
    type,
    locale,
    month,
    isOpen,
    setIsOpen,
    withInput,
    dateFormat,
    handleOnClose,
    handleResetClick,
    setDisableConfirmButton,
    placeholder,
    setMonth,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(DatepickerProvider, {
    type: type,
    month: month,
    locale: locale,
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    withInput: withInput,
    dateFormat: dateFormat,
    handleOnClose: handleOnClose,
    handleResetClick: handleResetClick,
    setDisableConfirmButton: setDisableConfirmButton,
    placeholder: placeholder,
    setMonth: setMonth
  }, /*#__PURE__*/React.createElement(Datepicker, restProps));
}
DatepickerWrapper.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  month: PropTypes.instanceOf(Date),
  type: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  withInput: PropTypes.bool.isRequired,
  dateFormat: PropTypes.string.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  handleResetClick: PropTypes.func.isRequired,
  setDisableConfirmButton: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  setMonth: function (props, propName) {
    if (props['type'] && isRangeSelectionDatePicker(props['type']) && typeof props[propName] !== 'function') {
      return new Error(`prop ${propName} type of function must be supplied when using dates range picker.`);
    }
  }
};
DatepickerProvider.defaultProps = {
  locale: 'en',
  isOpen: false,
  withInput: false,
  month: new Date(),
  setIsOpen: () => {},
  handleOnClose: () => {},
  handleResetClick: () => {},
  dateFormat: DEFAULT_DATE_FORMAT,
  setDisableConfirmButton: () => {},
  type: DATE_PICKER_TYPE.SINGLE_SELECTION,
  placeholder: '',
  setMonth: () => {}
};
export default DatepickerWrapper;